import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteSimApn = async (apnId: string): Promise<boolean> =>
  axios.delete(`/management/simapn/removesimapn?apnId=${apnId}`).then((res) => res?.data?.result)

type Props = {
  apnId: string
}

export const useManagementDeleteSimApn = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteSimApn'],
    mutationFn: ({ apnId }: Props) => deleteSimApn(apnId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted sim apn.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete sim apn, please try again.')
      }
    },
    throwOnError: false
  })
